module.exports = __webpack_public_path__ + "static/media/slideImgTwo@2x.def33c7f.png";